<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-ibox :is-loading="isLoadingModal">
        <div slot="body">

          <div class="alert alert-warning">
            <span style="color: red;"> توجه: </span>
            لطفا یکی از فیلد های شماره تلفن یا کد ملی را وارد کنید بقیه اطلاعات به صورت اتوماتیک پر می شود. 
            <br />
            بعد پولی را که می خواهید کم شود از اعتبار کاربر در قسمت کاهش اعتبار قرار دهید و توضیحات خود را در مورد دلیل کم شدن نوشته و روی ذخیره کلیک کنید.
          </div>

          <bita-formgroup title="اطلاعات راننده" class="row mb-2">

            <bita-input
              type="text"
              name="phone"
              label="شماره همراه"
              rules="required|mobile"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.phone"
              @change="findDriver(dataForm.phone, 0)"
            />

            <bita-input
              type="text"
              name="nationalCode"
              label="کد ملی"
              rules="required|irani"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.national_code"
              @change="findDriver(0, dataForm.national_code)"
            />

            <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.name"
              disabled
            />

            <bita-input
              type="text"
              name="family"
              label="نام خانوادگی"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.family"
              disabled
            />

            <bita-input
              type="text"
              name="balance"
              label="اعتبار راننده (تومان)"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.balance"
              disabled
              :subtitle="dataForm.balance ? $thousandSeprator(dataForm.balance) : ''"
            />

          </bita-formgroup>

          <bita-formgroup title="کاهش اعتبار" class="row align-items-center mb-2 mt-3">

            <bita-input
              type="text"
              name="price"
              label=" مبلغ (تومان)"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="price"
              :subtitle="price ? $thousandSeprator(price) : ''"
              :disabled="!dataForm.balance"
            />

            <bita-input
              type="text"
              name="description"
              label="توضیحات"
              rules="required"
              class="col-lg-8"
              input-class="form-control"
              v-model="dataForm.description"
              :disabled="!dataForm.balance"
            />
            
            <div class="col-auto">
              <bita-bootbutton
                type="primary"
                title="ذخیره کردن"
                icon="fa fa-check"
                btn-width="150px"
                @click.native="handleSubmit()"
              />
            </div>

          </bita-formgroup>

        </div>
      </bita-ibox>
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: String,
    title: String,
    isLoading: Boolean,
  },

  data() {
    return {
      dataForm: {},
      price: null,
      isLoadingModal: false,
      isLoadingGrid: false,
      colWidth: "col-lg-4",
    };
  },

  methods: {

    findDriver(phone, national_code) {
      if (this.$ssnIsValid(national_code) || phone.length == 11) {
        this.$persistClient(
          "get",
          `drivers/find?phone=${phone}&national_code=${national_code}`
        ).then((res) => {
          let response = res.data.data;
          if (response) {
            this.dataForm = {
              user_id: response.id,
              name: response.name,
              family: response.family,
              phone: response.phone,
              national_code: response.national_code,
              balance: response.balance.balance
            };
          } else {
            this.reset();
          }
        }).catch( () => {
          this.reset();
        });
      }
    },

    reset() {
      this.dataForm = {};
      this.price = null;
    },

    onCloseModal() {
      this.dataForm = {};
      this.price = null;
    },

    handleSubmit() {
      let data = {
        user_id: this.dataForm.user_id,
        description: this.dataForm.description,
        price: this.price
      };
      this.reset();
      this.$emit("on-submit", data);
    },
  },
};
</script>